import type { ReactElement } from 'react';

import STYLES from './GraphicPromoCard.module.scss';

const cardWidth = 3;
const cardHeight = 4;

// TODO: CLOV-1913 Cannot migrate to Pure Backpack: paddingBottom is a dynamic inline style (DoD #4
// violation). The fix requires converting to a CSS custom property (--aspect-ratio) consumed by
// calc() in SCSS — which qualifies as a BpkVessel hard case — but adoption is disputed.
export const EmptyCard = (): ReactElement => {
  const aspectRatio = `${100 / (cardWidth / cardHeight)}%`;

  return (
    <div
      style={{
        paddingBottom: aspectRatio,
      }}
      className={STYLES.emptyCard}
      data-testid="graphicPromo__emptyCard"
    />
  );
};
